import { NgIf } from '@angular/common';
import { Component, EventEmitter, Input, Output, computed, signal } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';
import { BusinessPartner } from '@oe-backend/types';
import { HeadlineComponent, TextComponent } from '@zeiss/beyond-online-angular';
import { LoadingAnimationDirective } from 'src/app/modules/loading-animation/loading-animation.directive';
import { AutoCompleteModule, IconButtonComponent, IconComponent } from 'vis-ods-angular';
import { StoreSelectorConfig } from './store-selector.type';

@Component({
	selector: 'app-store-selector',
	templateUrl: './store-selector.component.html',
	imports: [
		TranslocoModule,
		NgIf,
		IconButtonComponent,
		AutoCompleteModule,
		IconComponent,
		HeadlineComponent,
		TextComponent,
		LoadingAnimationDirective,
	],
})
export class StoreSelectorComponent {
	@Input({ required: true }) storesLoading: boolean = true;
	@Input({ required: true }) stores!: BusinessPartner[];
	@Input({ required: true }) selectedStore?: BusinessPartner;
	@Input() config: Partial<StoreSelectorConfig> = {};

	@Output() navigateToMainMenu: EventEmitter<void> = new EventEmitter<void>();
	@Output() storeSelected = new EventEmitter<BusinessPartner>();

	public $filteredStores = computed(() => {
		const searchTerm = this.$searchTerm().toLowerCase();
		return this.stores.filter(
			(store) =>
				store.firstLineName?.toLowerCase().includes(searchTerm) ||
				store.secondLineName?.toLowerCase().includes(searchTerm) ||
				store.thirdLineName?.toLowerCase().includes(searchTerm) ||
				store.fourthLineName?.toLowerCase().includes(searchTerm) ||
				store.city?.toLowerCase().includes(searchTerm) ||
				store.street?.toLowerCase().includes(searchTerm) ||
				store.houseNumber?.toLowerCase().includes(searchTerm),
		);
	});

	private $searchTerm = signal<string>('');

	onStoreChange(store: BusinessPartner) {
		this.storeSelected.emit(store);
	}

	isSelected(store: BusinessPartner): boolean {
		if (!this.selectedStore) return false;
		return this.selectedStore.customerNumber === store.customerNumber;
	}

	backToMainMenu() {
		this.navigateToMainMenu.emit();
	}

	searchTermChanged(searchTerm: string) {
		this.$searchTerm.set(searchTerm);
	}
}
